import { render, staticRenderFns } from "./TrademarkStatus.vue?vue&type=template&id=44a373f2&"
import script from "./TrademarkStatus.vue?vue&type=script&lang=js&"
export * from "./TrademarkStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports